module.exports = __webpack_public_path__ + "components/flag/static/square/kr-83cce4b3273bfd6d45a04fdd3ff9c497.svg";